// src/components/ui/LoadingScreen.js
export function LoadingScreen() {
  return (
    <div style={styles.page}>
      <span style={styles.logo}>⬡</span>
      <div style={styles.spinner} />
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f8f7f4',
    gap: 20,
  },
  logo: {
    fontSize: 40,
    color: '#7eb86a',
  },
  spinner: {
    width: 24,
    height: 24,
    border: '2px solid #e0dbd4',
    borderTopColor: '#7eb86a',
    borderRadius: '50%',
    animation: 'spin 0.7s linear infinite',
  },
};
